(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-b7-color]');
    if (!btn) return;

    e.preventDefault();

    var card = btn.closest('.product-card');
    if (!card) return;

    // 1) 썸네일 교체
    var imgs = card.querySelectorAll('.preview img');
    var main = imgs[0];
    var sub = imgs[1];

    if (main && btn.dataset.img) {
      main.removeAttribute('srcset');
      main.src = btn.dataset.img;
    }
    if (sub) {
      if (btn.dataset.img2) {
        sub.removeAttribute('srcset');
        sub.src = btn.dataset.img2;
        sub.style.display = '';
      } else {
        sub.style.display = 'none';
      }
    }

    // 2) curr 상태 이동
    var items = card.querySelectorAll('.b7-product-color__item');
    for (var i = 0; i < items.length; i++) items[i].classList.remove('curr');

    var li = btn.closest('.b7-product-color__item');
    if (li) li.classList.add('curr');

    // 3) 카드 링크를 선택한 색 상품으로
    if (btn.dataset.url) {
      var links = card.querySelectorAll('a[href]');
      for (var j = 0; j < links.length; j++) links[j].href = btn.dataset.url;
    }
  });
})();